import { evidenceCsv, evidenceRows, csvCell } from './presentation.js';
function download(blob, name) {
  const url=URL.createObjectURL(blob), link=document.createElement('a');
  link.href=url; link.download=name; document.body.append(link); link.click(); link.remove();
  setTimeout(()=>URL.revokeObjectURL(url),1000);
}
export async function exportEvidence(turn, type='csv') {
  if (turn.answer?.documents?.length && type==='csv') {
    const documents = [['Document', 'Revision', 'Locator', 'Excerpt'], ...turn.answer.documents.map(d => [d.title, d.revision_id, d.locator, d.text])].map(row => row.map(csvCell).join(',')).join('\r\n');
    download(new Blob(['\uFEFF', evidenceCsv(turn), '\r\n\r\n', documents], { type: 'text/csv;charset=utf-8' }), 'orbit-ai-evidence.csv'); return;
  }
  if (type==='csv') { download(new Blob(['\uFEFF',evidenceCsv(turn)],{type:'text/csv;charset=utf-8'}),'orbit-ai-evidence.csv'); return; }
  const { default: ExcelJS }=await import('exceljs');
  const book=new ExcelJS.Workbook(), sheet=book.addWorksheet('Evidence');
  const rows=evidenceRows(turn), columns=Object.keys(rows[0] || {});
  sheet.addRow(columns); rows.forEach(row=>sheet.addRow(columns.map(key=>row[key])));
  if (turn.answer?.documents?.length) { const docs = book.addWorksheet('Document references'); docs.addRow(['Document', 'Revision', 'Locator', 'Excerpt']); turn.answer.documents.forEach(d => docs.addRow([d.title, d.revision_id, d.locator, d.text])); }
  sheet.views=[{state:'frozen',ySplit:1}]; if (columns.length) sheet.autoFilter={from:{row:1,column:1},to:{row:1,column:columns.length}};
  sheet.columns.forEach(column=>{column.width=24;});
  download(new Blob([await book.xlsx.writeBuffer()],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),'orbit-ai-evidence.xlsx');
}
